import gql from 'graphql-tag';
import { DEAL_ACTIVITY_FRAGMENT } from './fragments/dealEventActivity.fragment';

export const DEAL_ACTIVITY = gql`
  query DealActivity($input: DealActivityInput!) {
    dealActivity {
      result: dealActivity(input: $input) {
        error
        success
        entity {
          __typename
          ...DealEventActivityFields
        }
      }
    }
  }
  ${DEAL_ACTIVITY_FRAGMENT}
`;
